<template>
  <div class="space-y-4">
    <!-- Basic Information -->
    <div class="grid grid-cols-2 gap-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">
          Type *
        </label>
        <input
          v-model="entryData.type"
          type="text"
          class="w-full px-3 py-2 border border-gray-300 rounded-md
           focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="e.g., assessment, devTip"
          :disabled="!!entry._id"
        />
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">
          Label *
        </label>
        <input
          v-model="entryData.label"
          type="text"
          class="w-full px-3 py-2 border border-gray-300 rounded-md
           focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="e.g., Assessment Schemas"
        />
      </div>
    </div>

    <div>
      <label class="block text-sm font-medium text-gray-700 mb-1">
        Description
      </label>
      <textarea
        v-model="entryData.description"
        rows="3"
        class="w-full px-3 py-2 border border-gray-300 rounded-md
         focus:outline-none focus:ring-2 focus:ring-blue-500"
        placeholder="Description of this activity type"
      ></textarea>
    </div>

    <div class="grid grid-cols-2 gap-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">
          Development points per completion *
        </label>
        <input
          v-model="entryData.xpPerCompletion"
          type="number"
          min="0"
          class="w-full px-3 py-2 border border-gray-300 rounded-md
           focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Base development points reward"
        />
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">
          Goal Type *
        </label>
        <input
          v-model="entryData.goalType"
          type="text"
          class="w-full px-3 py-2 border border-gray-300 rounded-md
           focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="e.g., assessment, devTip"
        />
      </div>
    </div>

    <!-- Collection Information -->
    <div class="grid grid-cols-2 gap-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">
          Collection *
        </label>
        <input
          v-model="entryData.collection"
          type="text"
          class="w-full px-3 py-2 border border-gray-300 rounded-md
           focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="e.g., schemas, devTips"
        />
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">
          User Field *
        </label>
        <input
          v-model="entryData.userField"
          type="text"
          class="w-full px-3 py-2 border border-gray-300 rounded-md
           focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="e.g., userId"
        />
      </div>
    </div>

    <!-- Flags and Validation -->
    <div class="grid grid-cols-2 gap-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">
          Is Dynamic
        </label>
        <div class="flex items-center">
          <input
            v-model="entryData.isDynamic"
            type="checkbox"
            class="mr-2 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
          />
          <span class="text-sm text-gray-600">
            Dynamic entries (like assessment schemas)
          </span>
        </div>
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">
          Requires Assessment Type
        </label>
        <div class="flex items-center">
          <input
            v-model="entryData.requiresAssessmentType"
            type="checkbox"
            class="mr-2 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
          />
          <span class="text-sm text-gray-600">
            Goals require assessmentType field
          </span>
        </div>
      </div>
    </div>

    <!-- Validation Rules -->
    <div class="border border-gray-200 rounded-lg p-4">
      <h4 class="font-medium mb-3">Validation Rules</h4>
      <div class="grid grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">
            Requires Schema Flag
          </label>
          <div class="flex items-center">
            <input
              v-model="entryData.validation.requiresSchemaFlag"
              type="checkbox"
              class="mr-2 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
            />
            <span class="text-sm text-gray-600">
              Schema must have levelSystemEnabled flag
            </span>
          </div>
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">
            Min development points per completion *
          </label>
          <input
            v-model="entryData.validation.minXpPerCompletion"
            type="number"
            min="1"
            class="w-full px-3 py-2 border border-gray-300 rounded-md
             focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Minimum development points required"
          />
        </div>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="flex justify-end space-x-3 pt-4 border-t">
      <Button
        label="Cancel"
        severity="secondary"
        @click="$emit('cancel')"
      />
      <Button
        label="Save Entry"
        icon="pi pi-check"
        @click="saveEntry"
        :disabled="!isValid"
      />
    </div>
  </div>
</template>

<script>
import Button from 'primevue/button';

export default {
  name: 'RegistryEntryDialog',
  components: {
    Button,
  },
  props: {
    entry: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      entryData: {
        type: '',
        label: '',
        description: '',
        xpPerCompletion: 0,
        collection: '',
        userField: '',
        isDynamic: false,
        goalType: '',
        requiresAssessmentType: false,
        validation: {
          requiresSchemaFlag: false,
          minXpPerCompletion: 1,
        },
      },
    };
  },
  computed: {
    isValid() {
      return (
        this.entryData.type.trim() !== '' &&
        this.entryData.label.trim() !== '' &&
        this.entryData.xpPerCompletion >= 0 &&
        this.entryData.collection.trim() !== '' &&
        this.entryData.userField.trim() !== '' &&
        this.entryData.goalType.trim() !== '' &&
        this.entryData.validation.minXpPerCompletion > 0
      );
    },
  },
  watch: {
    entry: {
      handler(newEntry) {
        if (newEntry) {
          this.entryData = { ...newEntry };
        } else {
          this.resetForm();
        }
      },
      immediate: true,
    },
  },
  methods: {
    resetForm() {
      this.entryData = {
        type: '',
        label: '',
        description: '',
        xpPerCompletion: 0,
        collection: '',
        userField: '',
        isDynamic: false,
        goalType: '',
        requiresAssessmentType: false,
        validation: {
          requiresSchemaFlag: false,
          minXpPerCompletion: 1,
        },
      };
    },

    saveEntry() {
      if (this.isValid) {
        this.$emit('save', { ...this.entryData });
      }
    },
  },
};
</script>

<style scoped>
/* Component-specific styles can be added here */
</style>
